<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xml:space="preserve"
        :width="width"
        :height="height"
        version="1.1"
        style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
        viewBox="0 0 102 195.302"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xmlns:xodm="http://www.corel.com/coreldraw/odm/2003"
    >
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.channel}"
            @click="select('channel')"
            d="M48.361 114.417c3.666,-23.028 3.673,-26.207 -2.211,-58.645 2.555,-7.295 11.266,28.789 6.854,60.243 -1.18,-0.477 -2.469,-0.812 -4.643,-1.598z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.first}"
            @click="select('first')"
            d="M58.206 178.828c3.94,0.179 7.731,0.733 11.374,1.661 -4.855,7.014 -11.662,11.294 -19.067,11.054 -6.472,-0.21 -12.265,-3.837 -16.553,-9.631 6.191,-1.723 12.102,-2.739 17.734,-3.048 2.214,-0.121 4.385,-0.134 6.512,-0.036z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.secondLeft}"
            @click="select('secondLeft')"
            d="M48.993 136.993c-3.718,21.511 -2.818,35.468 2.701,41.871 -5.632,0.309 -11.543,1.325 -17.734,3.048 -4.957,-6.699 -7.902,-16.295 -7.56,-26.859 0.2,-6.14 1.486,-11.883 3.586,-16.865 0.727,-1.724 1.55,-3.356 2.459,-4.883 5.578,2.628 11.095,3.857 16.548,3.688z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.six}"
            @click="select('six')"
            d="M51.694 178.864c-5.519,-6.403 -6.419,-20.36 -2.701,-41.871 3.772,-0.116 7.514,-0.902 11.227,-2.356 0.742,11.714 0.071,26.445 -2.014,44.191 -2.127,-0.098 -4.298,-0.085 -6.512,0.036z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.secondRight}"
            @click="select('secondRight')"
            d="M58.206 178.828c2.085,-17.746 2.756,-32.477 2.014,-44.191 3.315,-1.299 6.607,-3.131 9.875,-5.496 0.694,0.827 1.349,1.704 1.96,2.63 0.932,1.412 1.76,2.937 2.463,4.563 2.481,5.739 2.658,13.06 2.422,20.359 -0.3,9.247 -3.066,17.591 -7.36,23.796 -3.643,-0.928 -7.434,-1.482 -11.374,-1.661z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.fifth}"
            @click="select('fifth')"
            d="M69.977 129.226c-10.847,7.805 -22.143,9.672 -33.55,5.721 -1.324,-0.468 -2.651,-1.015 -3.982,-1.642 4.897,-8.217 12.282,-13.364 20.382,-13.102 6.359,0.206 12.67,3.458 17.268,8.938 -0.04,0.028 -0.079,0.057 -0.118,0.085z"
        />
        <path
            class="fil0 str1"
            :class="{redBorder:redBorder}"
            d="M72.055 131.77c-3.869,-33.621 -9.217,-61.591 -19.902,-88.741 -5.351,-13.598 -14.804,-13.902 -16.052,1.182 -3.062,37.031 3.011,58.018 -6.115,93.977m46.954 18.505c0.236,-7.299 0.059,-14.62 -2.422,-20.359 -4.216,-9.749 -12.907,-15.847 -21.691,-16.131 -13.955,-0.452 -25.788,15.151 -26.427,34.85 -0.639,19.7 10.158,36.037 24.113,36.49 13.956,0.453 25.789,-15.151 26.427,-34.85z"
        />
    </svg>
</template>

<script>
import { toothMixins } from '@/mixins/tooth.js'
export default {
    mixins: [toothMixins]
}
</script>
